<template>
    <v-fade-transition>
        <v-sheet
            v-show="expand && isExportSuccess !== null"
            :height="500"
            class="d-flex flex-column"
        >
            <v-img
                class="mt-5"
                :width="150"
                :max-height="150"
                contain
                :src="getImageByState"
            />
            <div
                class="h2 download-title green-text text-darken-2 font-weight-bold pt-3 pb-6"
                :class="{
                    'green-text': isExportSuccess,
                    'orange-text': !isExportSuccess
                }"
            >
                {{ getTextByState }}
            </div>
            <v-card-text
                v-if="isExportSuccess"
                class="pa-0 habiteo-body-2"
                style="line-height: 20px;"
                v-html="getInfo"
            />
            <v-spacer/>
        </v-sheet>
    </v-fade-transition>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'LastStep',
        data() {
            return {
                expand: false,
                exportSuccessImg: require('@/assets/images/export-success.png'),
                exportFailImg: require('@/assets/images/export-fail.png')
            }
        },
        props: {
            isDownloadSuccess: {
                type: Boolean,
                required: true
            },
            isImportSuccess: {
                type: Boolean,
                required: true
            },
            isAProgram: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            getImageByState() {
                return this.isExportSuccess ? this.exportSuccessImg : this.exportFailImg;
            },
            getTextByState() {
                return this.isDownloadSuccess ? this.$t('habiteoStudio.downloadComplete') :
                    this.isImportSuccess ? this.$t('habiteoStudio.importComplete') :
                    this.$t('habiteoStudio.downloadFailed');
            },
            getInfo() {
                return this.isDownloadSuccess ? this.$t('habiteoStudio.downloadCompleteInfo') :
                    this.isImportSuccess ? ( this.$props.isAProgram ? this.$t('habiteoStudio.importCompleteInfoProgram') : this.$t('habiteoStudio.importCompleteInfo')) :
                    "";
            },
            isExportSuccess() {
                return this.isDownloadSuccess || this.isImportSuccess;
            }
        },
        mounted() {
            EventBus.$on('setDownloadState', state => this.sucess = state);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/LastStep.vue